// Team members shown in the home/about carousel.
// objectPosition controls how the photo is cropped to fit the slide (50% horizontal, Y%).
// Lower Y% = show more of the top of the photo (good for keeping face visible).
export const TEAM = [
  {
    id: "team-group",
    name: "Nuestro Equipo",
    role: "Master Credit Group",
    bio: "Tres especialistas, una misión: devolverte el control de tu crédito y abrirte las puertas a la libertad financiera.",
    image:
      "https://customer-assets.emergentagent.com/job_credit-fix-hub-1/artifacts/d63xohsk_WhatsApp%20Image%202026-05-02%20at%2010.29.57%20AM.jpeg",
    accent: "Equipo",
    objectPosition: "50% 35%",
  },
  {
    id: "ceo",
    name: "CEO · Master Credit",
    role: "Director Ejecutivo",
    bio: "Más de una década liderando la firma. Visión y experiencia para guiar cada caso con resultados reales.",
    image:
      "https://customer-assets.emergentagent.com/job_credit-fix-hub-1/artifacts/i2d1vn6g_AN8A6245.jpg.jpeg",
    accent: "Liderazgo",
    objectPosition: "50% 22%",
  },
  {
    id: "expert-1",
    name: "Experto Senior",
    role: "Finanzas y Reparación de Crédito",
    bio: "Estrategia personalizada para cada cliente: disputas, consolidación y construcción de historial sólido.",
    image:
      "https://customer-assets.emergentagent.com/job_credit-fix-hub-1/artifacts/zjr12ohv_AN8A6228.jpg.jpeg",
    accent: "Estrategia",
    objectPosition: "50% 22%",
  },
  {
    id: "expert-2",
    name: "Experto Senior",
    role: "Finanzas y Reparación de Crédito",
    bio: "Especializado en eliminar cuentas negativas y preparar a las familias para grandes metas como hipoteca o auto.",
    image:
      "https://customer-assets.emergentagent.com/job_credit-fix-hub-1/artifacts/agbzvqf7_AN8A6259.jpg.jpeg",
    accent: "Resultados",
    objectPosition: "50% 18%",
  },
];
